export default "__VITE_ASSET__D6sO5IPx__"